module.exports = __webpack_public_path__ + "static/media/card-product3.1cd31fc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/card-product3.jpg
// module id = 1271
// module chunks = 0